var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeerVideoPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1735",
    "data-name": "Group 1735",
    transform: "translate(-2595 623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_597",
    "data-name": "Rectangle 597",
    transform: "translate(2597 -621)",
    stroke: "#fff",
    strokeWidth: 2,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 32,
    height: 32,
    rx: 16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_79",
    "data-name": "Polygon 79",
    d: "M7,0l7,9H0Z",
    transform: "translate(2618 -613) rotate(90)",
    fill: "#fff",
    opacity: 0.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeerVideoPlay);
export default __webpack_public_path__ + "static/media/peerVideoPlay.6ef7e43ce662b7c3fa08d490c9032a32.svg";
export { ForwardRef as ReactComponent };